var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaProfiloOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.99949 19.99992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.99974,9.47361A4.73681,4.73681,0,1,1,14.73655,4.7368,4.742,4.742,0,0,1,9.99974,9.47361Zm0-8.421A3.68419,3.68419,0,1,0,13.68393,4.7368,3.68865,3.68865,0,0,0,9.99974,1.05262Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.98973,19.38994a.48776.48776,0,0,1-.11.42.54835.54835,0,0,1-.41.19h-7.36a.52861.52861,0,0,1-.49-.32.53785.53785,0,0,1,.11-.58l3.16-3.16a.53033.53033,0,0,1,.75.75l-2.26,2.26h5.47l-1.21-7.29a4.45363,4.45363,0,0,0-1.2-2.36,7.89225,7.89225,0,0,1-12.88,0,4.45363,4.45363,0,0,0-1.2,2.36l-1.21,7.29h5.47l-2.26-2.26a.53033.53033,0,0,1,.75-.75l3.16,3.16a.53785.53785,0,0,1,.11.58.52861.52861,0,0,1-.49.32h-7.36a.54835.54835,0,0,1-.41-.19.48779.48779,0,0,1-.11-.42l1.31-7.9a5.46857,5.46857,0,0,1,1.54-2.99l.42-.42a.586.586,0,0,1,.17-.1.5257.5257,0,0,1,.39,0,.45182.45182,0,0,1,.17.11.55294.55294,0,0,1,.07.09s.02.01.02.02a6.8395,6.8395,0,0,0,11.80005,0,.00979.00979,0,0,1,.00995-.01.0098.0098,0,0,0,.01-.01.55341.55341,0,0,1,.07-.09.45193.45193,0,0,1,.17-.11.5257.5257,0,0,1,.39,0,.586.586,0,0,1,.17.1l.42.42a5.47433,5.47433,0,0,1,1.54,2.98Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaProfiloOut);
export default __webpack_public_path__ + "static/media/iconaProfiloOut.c9575f89634b4640696fd07acf5f467a.svg";
export { ForwardRef as ReactComponent };